// extracted by mini-css-extract-plugin
export default {"controls":"i9KvM","increment":"_l4Jx","decrement":"_7bi8Y"};